<template>
  <VCard class="detail-summary-wrapper">
    <VBlock :direction="Direction.column" :padding="[30, 15, 20, 15]">
      <VBlock :direction="Direction.column" :sort="Sort.left_center" :margin="[0, 0, 20, 0]">
        <!-- TODO 예약배달 칩 -->
        <VSpan
          v-if="isVisibleStatusText"
          :text="statusText"
          :color="orderDetailSummary.status === 'CANCELLED' ? TextColor.emergency : TextColor.gray2"
          :weight="TextWeight.regular"
          :size="16"
          :spacing="-0.38"
        />
        <VSpan :text="orderDetailSummary.shopName || ''" :size="20" :weight="TextWeight.bold" :spacing="-0.47" />
        <VSpan
          :text="
            !!orderDetailSummary.orderName
              ? `${orderDetailSummary.orderName} ${orderDetailSummary.paymentAmount}원`
              : ''
          "
          :size="16"
          :type="TextType.Number"
          :spacing="-0.38"
        />
        <VBlock class="reservation-wrapper" :margin="[2, 0, 0, 0]" v-if="orderDetailReservation.reservation">
          <VSpan class="reservation-text" text="예약" :size="10" :color="TextColor.gray3" :spacing="-0.38" />
        </VBlock>
      </VBlock>

      <VBlock :direction="Direction.column" :sort="Sort.left_center" :margin="[0, 0, 10, 0]">
        <VSpan
          :text="`주문일시: ${orderDetailSummary.orderedDateTime}`"
          :size="16"
          :spacing="-0.43"
          :color="TextColor.gray2"
        />
        <VSpan
          :text="`주문번호: ${orderDetailSummary.convertedOrderId}`"
          :size="16"
          :spacing="-0.43"
          :color="TextColor.gray2"
        />
      </VBlock>

      <!-- TODO 배달현황 check src/components/my/order/MoveDeliveryTracking.vue:1 -->
      <!-- TODO 영수증 받기 check src/components/my/order/MoveReceiptSending.vue:1 -->
      <VBlock v-if="!chatbot" :direction="Direction.row" :sort="Sort.left_center" :margin="[0, 0, 20, 0]">
        <VA
          v-if="isShowCashReceipts"
          :onClick="
            () => {
              onCashReceipts(orderDetailPayment.paymentKey)
            }
          "
          class="receiptBtn"
        >
          <VSpan class="receiptText" :size="11" :spacing="-0.35" text="현금영수증 보기" />
        </VA>

        <VA
          v-if="isShowReceiptSending"
          :onClick="
            () => {
              onReceiptSending(orderDetailPayment.paymentKey)
            }
          "
          class="receiptBtn"
        >
          <VSpan class="receiptText" :size="11" :spacing="-0.35" text="영수증 받기" />
        </VA>
      </VBlock>

      <VBlock v-if="!chatbot" class="order-history-button-wrapper">
        <VA class="order-history-button" :link="`tel:${customerServiceTelephoneNumber}`" :onClick="customerCenterLog">
          <VBlock class="order-history-button-inner">
            <VBlock class="order-history-button-image-wrapper" :padding="[0, 4, 2, 0]">
              <VImage :src="resources.customerCenterCallIcon" :width="25" :height="25" />
            </VBlock>
            <VSpan text="고객센터" :size="14" />
          </VBlock>
        </VA>
        <VButton
          v-if="isShowChatbotButton"
          :class="{ 'order-history-button': true, 'left-blank': isShowChatbotButton }"
          :onClick="
            () => {
              onChatbot(orderDetailSummary.convertedOrderId)
            }
          "
          :radius="4"
        >
          <VBlock class="order-history-button-inner">
            <VBlock class="order-history-button-image-wrapper" :padding="[0, 4, 2, 0]">
              <VImage :src="resources.chatbotIcon" :width="25" :height="25" />
            </VBlock>
            <VSpan text="채팅상담" :size="14" />
          </VBlock>
        </VButton>
      </VBlock>

      <!-- <VBlock class="summary-button-wrapper">
        <VA
          class="summary-call-button"
          :link="`tel:${customerServiceTelephoneNumber}`"
          :onClick="customerCenterLog"
        >
          <VBlock class="summary-button">
            <VSpan text="고객센터 전화" :size="14" :spacing="-0.35" />
          </VBlock>
        </VA>
      </VBlock>-->
    </VBlock>
  </VCard>
</template>

<script>
import VCard from '../../molecules/VCard'
import VBlock, { Direction, Sort } from '../../molecules/VBlock'
import VSpan, { TextColor, TextWeight, TextType } from '../../atoms/VSpan'
import VA from '../../molecules/VA'
import VImage from '../../atoms/VImage'
import VButton from '../../atoms/VButton'

import { isProvideChatbotOpen } from '../../../../../../config/featureProvider'

import deliveryReturnIcon from '@/assets/images/delivery-return.svg'
import customerCenterCallIcon from '@/assets/images/customer-center-call-normal.svg'
import chatbotIcon from '@/assets/images/call-normal.svg'

export default {
  name: 'OrderDetailSummary',
  components: { VA, VSpan, VBlock, VCard, VImage, VButton },
  props: {
    chatbot: {
      type: Boolean,
      required: true
    },
    onChatbot: {
      type: Function,
      required: true
    },
    chatbotStatus: {
      type: Object,
      required: true
    },
    onBmartMove: {
      type: Function,
      required: true
    },
    orderDetailSummary: {
      type: Object, // src/v2-models/MyOrder/OrderDetailSummary.js:3
      required: true
    },
    orderDetailPayment: {
      type: Object, // src/v2-models/MyOrder/OrderDetailPayment.js:1
      required: true
    },
    orderDetailReservation: {
      type: Object, // src/models/MyOrder/OrderDetailReservation.js:1
      required: true
    },
    onReceiptSending: {
      type: Function,
      required: true
    },
    onCashReceipts: {
      type: Function,
      required: true
    },
    customerServiceTelephoneNumber: {
      type: String,
      required: true
    },
    cashReceipt: {
      type: Object,
      required: true
    },
    customerCenterLog: {
      type: Function,
      required: true
    }
  },
  computed: {
    isShowChatbotButton() {
      const { appVersion, isAndroid } = this.$store.getters

      return (
        this.orderDetailSummary.isMember &&
        isProvideChatbotOpen({ appVersion, isAndroid }) &&
        this.chatbotStatus.isOperating() &&
        this.chatbotStatus.isServiceArea() &&
        !this.chatbotStatus.isClosedCenter() &&
        (this.orderDetailSummary.status === 'COMPLETED' || this.orderDetailSummary.status === 'CANCELLED')
      )
    },

    isShowReceiptSending() {
      // TODO check src/components/my/order/SummaryInfo.vue:47
      return this.orderDetailSummary.isReceiptButtonExposure()
    },
    isShowCashReceipts() {
      // TODO implement 현금영수증 보기; 현재는 현금성 결제 미지원
      return (
        this.cashReceipt &&
        this.cashReceipt.showCashReceipt &&
        this.orderDetailSummary.status === 'COMPLETED' &&
        this.cashReceipt.status !== 'CANCEL'
      )
    },
    statusText() {
      // if (orderDetailSummary.status === 'PRODUCT_PREPARATION') {
      //   return
      // } else if (orderDetailSummary.status === 'DELIVERING') {
      //   return ''

      if (this.orderDetailSummary.status === 'COMPLETED') {
        return '배달이 완료되었어요'
      } else if (this.orderDetailSummary.status === 'CANCELLED') {
        return '주문이 취소되었습니다 (고객취소)'
      } else {
        return ''
      }
    },
    isVisibleStatusText() {
      return this.orderDetailSummary.status === 'COMPLETED' || this.orderDetailSummary.status === 'CANCELLED'
    }
  },
  data() {
    return {
      Direction,
      Sort,
      TextColor,
      TextType,
      TextWeight,

      resources: {
        deliveryReturnIcon,
        customerCenterCallIcon,
        chatbotIcon
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.detail-summary-wrapper {
  width: 100%;
  height: auto;

  border-bottom: 1px solid $light-gray-5;
  margin-bottom: 10px;

  & .receiptBtn {
    border-radius: 25px;
    background-color: $light-gray-8;
    padding: 2px 8px 2px 8px;
    box-sizing: border-box;

    &:first-child {
      margin-right: 6px;
    }

    & .receiptText {
    }
  }

  .reservation-wrapper {
    width: 28px;
    height: 18px;
    // padding: 5px;
    padding-top: 1px;
    background-color: $light-gray-8;
    margin-bottom: 8px;
    border-radius: 2px;

    .reservation-text {
      width: auto;
      height: auto;
    }
  }

  .summary-button-wrapper {
    width: 100%;
    height: auto;
    box-sizing: border-box;

    .summary-call-button {
      width: 100%;
      height: auto;
      padding: 17px 17px 17px 17px;

      border-radius: 4px;
      border: 1px solid $light-gray-4;
      text-align: center;

      .summary-button {
        width: 100%;
        height: auto;
      }
    }
  }

  .order-history-button-wrapper {
    width: 100%;
    height: auto;
    // padding: 0 10px 0 10px;
    box-sizing: border-box;
    margin-top: 4px;

    .left-blank {
      margin-left: 6px;
    }

    .order-history-button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 50px;
      padding: 0;
      box-sizing: border-box;
      /* border-collapse: collapse; */
      border: 1px solid $light-gray-4;
      border-radius: 4px;

      .order-history-button-inner {
        .order-history-button-image-wrapper {
          width: auto;
        }
      }

      // &:first-child {
      // margin-right: 6px;
      /* border-top-left-radius: 4px !important;
        border-bottom-left-radius: 4px !important; */
      // }

      // &:last-child {
      //   margin-left: 6px;
      /* margin-left: -1px;
        border-top-right-radius: 4px !important;
        border-bottom-right-radius: 4px !important; */
      // }
    }
  }
}
</style>
